/**
 * Scroll Reveal — FOG Theme
 * Minimal IntersectionObserver. Adds .is-visible once.
 * CSS handles all animation via @keyframes.
 */
(function () {
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  document.addEventListener('DOMContentLoaded', function () {
    // Ce qui est déjà dans l'écran (ou au-dessus) à l'init est affiché depuis le premier rendu :
    // le masquer pour le refaire apparaître en fondu faisait clignoter le contenu lu (haut de
    // /pages/contact, KPI de la home quand DOMContentLoaded arrive tard). On le marque révélé,
    // sans animation (data-reveal-done, exclu des sélecteurs de scroll-reveal.css) ; .is-visible
    // sert aux sections qui révèlent leurs enfants (luminaires-nav). Mesure d'abord, écrit ensuite.
    var els = document.querySelectorAll('[data-reveal]');
    var limite = window.innerHeight;
    var dejaVus = [];
    var aObserver = [];
    for (var i = 0; i < els.length; i++) {
      var r = els[i].getBoundingClientRect();
      if ((r.width || r.height) && r.top < limite) dejaVus.push(els[i]);
      else aObserver.push(els[i]);
    }
    for (var j = 0; j < dejaVus.length; j++) {
      dejaVus[j].setAttribute('data-reveal-done', '');
      dejaVus[j].classList.add('is-visible');
    }

    document.documentElement.classList.add('reveal-ready');

    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          entries[i].target.classList.add('is-visible');
          io.unobserve(entries[i].target);
        }
      }
    }, { threshold: 0.15 });

    for (var k = 0; k < aObserver.length; k++) io.observe(aObserver[k]);
  });
})();
